import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromJobs from '../reducers';
import * as fromSourcing from '../../job-sourcing-module/reducers';
import { ViewJobInfoPageComponent } from './view-job-info-page.component';

@Component({
  selector: 'mj-selected-job-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="wrapper">
      <router-outlet (activate)="onActivate($event)"></router-outlet>

      <mj-edit-job-tpl-nav
        [jobState]="jobState$ | async"
        [boardsToCheckout]="boardsToCheckout | async"
        [jobSourcing]="jobSourcingState$ | async"
      >
      </mj-edit-job-tpl-nav>
    </div>
  `,
  styles: ['.wrapper {padding: 30px}'],
})
export class SelectedJobPageComponent {
  // @ViewChild(SelectedJobInfoComponent, { static: false }) child: SelectedJobInfoComponent;
  jobState$: any;
  jobSourcingState$: any;
  boardsToCheckout: any;
  public child: any;

  constructor(private store: Store<fromJobs.State>) {
    this.jobState$ = this.store.select(fromJobs.getSelectedJob);
    this.jobSourcingState$ = this.store.select(
      fromSourcing.getSelectedJobSourcing
    );
    this.boardsToCheckout = this.store.select(
      fromSourcing.getSelectedBoardsToCheckout
    );
  }

  onActivate(componentRef) {
    if (componentRef instanceof ViewJobInfoPageComponent) {
      this.child = componentRef;
      return;
    }
  }
}
